import React from 'react';
import { Mail } from 'lucide-react';
import type { Region } from '@court-sync/shared';
import { PublicBookingUserFormStep } from './PublicBookingUserFormStep';
import type { UserFormData } from './schemas';
import type { UserFormReturn } from './types';

export type AcademyGuestRegistrationBlockProps = {
  registerSubmitting: boolean;
  form: UserFormReturn;
  onEmailSubmit: (data: UserFormData) => void | Promise<void>;
  submitButtonLabel?: string;
  defaultCountrySource?: { country?: string | null; region?: Region | null };
};

/**
 * Shared email/password registration block for academy-scoped guest flows
 * (public lesson booking register step, private lesson booking when logged out).
 */
export function AcademyGuestRegistrationBlock({
  registerSubmitting,
  form,
  onEmailSubmit,
  submitButtonLabel = 'Create account and continue',
  defaultCountrySource,
}: AcademyGuestRegistrationBlockProps) {
  return (
    <div className="relative rounded-lg border border-muted/60 bg-muted/20 p-4 pt-6 dark:bg-muted/10">
      <div className="absolute -top-3 left-4 flex rounded-md bg-background px-1">
        <span className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
          <Mail className="h-3.5 w-3.5" aria-hidden />
          Email & password
        </span>
      </div>
      <PublicBookingUserFormStep
        form={form}
        onSubmit={onEmailSubmit}
        isSubmitting={registerSubmitting}
        showFormHeading={false}
        submitButtonLabel={submitButtonLabel}
        defaultCountrySource={defaultCountrySource}
      />
    </div>
  );
}
